import { React, useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Col,
  Row,
  Radio,
  Select,
  Checkbox,
  Tooltip,
} from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
  ProductionSet,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePicker, Dropdown, Space, Divider, theme } from "antd";
import { DatePickerY, GlobalSet } from "../../../pageStyled";
import {
  getParentReelDetailsById,
  markParentReelsStatus,
  markParentSheetStatus,
  getJumboReelsForMapping,
  mapJumboReel,
  getCuttingParentReelDetailsById,
  markParentReelsRewindingStatus,
  markParentSheetCuttingStatus,
} from "../../../../Services/productionPlanningServices";
import moment from "moment";
import {
  weightUnit,
  lengthUnit,
} from "../../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../../Services/measurementService";
import { useNavigate, useLocation } from "react-router";
import { toHandlePOName } from "../../../../Utils/helper/helper";

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const { TextArea } = Input;
const { Option } = Select;
const productionStatusData = [
  { label: "Produced", value: "produced" },
  { label: "Rejected", value: "rejected" },
];
const shiftData = ["1st", "2nd", "3rd"];

const ClosedProductionDrawer = ({
  jobId,
  parentReelId,
  visible,
  onCloseProduction,
  setActionResponse,
  showToaster,
  reFetch,
  type,
  data,
  drawerState,
  machineCode,
  productCode,
  productSpec,
  parentWeight,
  parentWeightUnit,
  savedDate,
  savedShift,
  jobcardType,
  selectedMachineType,
  tabNo,
}) => {
  const location = useLocation();
  const history = useNavigate();
  const [productionStatus, setProductionStatus] = useState([]);
  const [parentReelDetails, setParentReelDetails] = useState();
  const [isDecimalInput, setIsDecimalInput] = useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [jumboReelData, setJumboReelData] = useState([]);
  const [mappedJumboRolls, setMappedJumboRolls] = useState([
    { number: null, weight_utilized: null, units: null },
  ]);
  const [jumboRoleDropdown, setJumboRoleDropdown] = useState(false);
  const [coreWeight, setCoreWeight] = useState(false);
  const [packagingWeight, setPackagingWeight] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [responseError, setResponseError] = useState("");
  const [form] = Form.useForm();
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isQtyGreater, setQtyGreater] = useState(false);
  const [isMarkLoading, setIsMarkLoading] = useState(false);

  const markReelsStatus = (body, machineType, mark = false) => {
    mark ? setIsMarkLoading(true) : setIsSaveLoading(true);
    if (machineType !== "cutter") {
      const rewindingDate = form.getFieldValue("rewindingDate");
      const formattedRewindingDate = moment(rewindingDate).format("YYYY-MM-DD");
      for (let i = 0; i < body?.length; i++) {
        if (!body[i].hasOwnProperty("includes_packaging_weight")) {
          body[i]["includes_packaging_weight"] = false;
        }
        if (!body[i].hasOwnProperty("includes_core_weight")) {
          body[i]["includes_core_weight"] = false;
        }
      }

      const rewinderBody = {
        data: body,
      };
      // markParentReelsStatus(rewinderBody)
      //   .then((response) => {
      //     setActionResponse({
      //       error: false,
      //       msg: "Production of the parent reel is successfully closed.",
      //     });
      //     showToaster();
      //     reFetch(true);
      //   })
      //   .catch((error) => {
      //     setActionResponse(error.response.data);
      //     showToaster();
      //   });
      // showToaster();
      let reqBody = {
        parent_reel_id: parentReelId,
        rewinding_date: formattedRewindingDate,
        rewinding_shift: form.getFieldValue("rewindingShift"),
        jumbo_reels: mappedJumboRolls,
      };
      if (jobcardType == "single_stage") {
        mapJumboReel(reqBody, "edit")
          .then((response) => {
            if (!response.data.error) {
              markParentReelsStatus(rewinderBody)
                .then((resp) => {
                  setActionResponse({
                    error: false,
                    msg: "Production of the parent reel is successfully closed.",
                  });
                  showToaster();
                  reFetch(true);
                  showResponseError("");
                  onCloseProduction();
                })
                .catch((error) => {
                  setActionResponse({
                    error: true,
                    msg: error.response.data.msg,
                  });
                  // showResponseError(error.response.data.msg);
                  showToaster();
                  reFetch(true);
                  onCloseProduction();
                });
              showToaster();
            }
          })
          .catch((error) => {
            // setActionResponse({
            //   error: true,
            //   msg: error.response.data.msg
            // });
            showResponseError(error.response.data.msg);
            console.log(error);
          })
          .finally(() => {
            setTimeout(() => {
              mark ? setIsMarkLoading(false) : setIsSaveLoading(false);
            }, 2500);
          });
        showToaster();
        // console.log(mappedJumboRolls);
      } else {
        mapJumboReel(reqBody, "edit")
          .then((response) => {
            if (!response.data.error) {
              markParentReelsRewindingStatus(rewinderBody)
                .then((resp) => {
                  setActionResponse({
                    error: false,
                    msg: "Production of the parent reel is successfully closed.",
                  });
                  showToaster();
                  reFetch(true);
                  showResponseError("");
                  onCloseProduction();
                })
                .catch((error) => {
                  setActionResponse({
                    error: true,
                    msg: error.response.data.msg,
                  });
                  // showResponseError(error.response.data.msg);
                  showToaster();
                  reFetch(true);
                  onCloseProduction();
                });
              showToaster();
            }
          })
          .catch((error) => {
            // setActionResponse({
            //   error: true,
            //   msg: error.response.data.msg
            // });
            showResponseError(error.response.data.msg);
            console.log(error);
          })
          .finally(() => {
            setTimeout(() => {
              mark ? setIsMarkLoading(false) : setIsSaveLoading(false);
            }, 2500);
          });
        showToaster();
      }
    } else {
      const cuttingDate = form.getFieldValue("cuttingDate");
      const formattedcuttingDate = moment(cuttingDate).format("YYYY-MM-DD");
      let multiStageDataArr = [];
      if (jobcardType == "multi_stage") {
        // let dataObj = {};
        body?.map((ele, index) => {
          let dataObj = {};
          if (ele.status == "rejected") {
            dataObj["id"] = ele.id;
            dataObj["status"] = ele.status;
            dataObj["comment"] = ele.comment;
            if (ele.number) {
              dataObj["number"] = ele.number;
            }
            if (ele.dispatch_date) {
              dataObj["dispatch_date"] = ele.dispatch_date;
            }
            if (ele?.rejected_quantity) {
              if (ele?.units?.quantity == "sheets") {
                dataObj["rejected_no_of_sheets"] = ele.rejected_quantity;
                if (ele?.quantity) {
                  dataObj["produced_no_of_sheets"] = ele.quantity;
                }
              } else {
                dataObj["rejected_weight"] = ele.rejected_quantity;
                let unitObj = { rejected_weight: ele?.units?.quantity };
                dataObj["units"] = unitObj;
                if (ele?.quantity) {
                  let prodUnitObj = { produced_weight: ele?.units?.quantity };
                  dataObj["produced_weight"] = ele.quantity;
                  dataObj["units"] = { ...dataObj["units"], ...prodUnitObj };
                }
              }
            }
          } else {
            dataObj["id"] = ele.id;
            dataObj["status"] = ele.status;
            if (ele.number) {
              dataObj["number"] = ele.number;
            }
            if (ele.dispatch_date) {
              dataObj["dispatch_date"] = ele.dispatch_date;
            }
            if (ele?.quantity) {
              if (ele?.units?.quantity == "sheets") {
                dataObj["produced_no_of_sheets"] = ele.quantity;
              } else {
                let prodUnitObj = { produced_weight: ele?.units?.quantity };
                dataObj["produced_weight"] = ele.quantity;
                dataObj["units"] = { ...dataObj["units"], ...prodUnitObj };
              }
            }
          }
          multiStageDataArr.push(dataObj);
        });
      }
      const cutterSingleStage = {
        cutting_date: formattedcuttingDate,
        cutting_shift: form.getFieldValue("cuttingShift"),
        parent_reel_id: parentReelId,
        data: body,
      };
      const cutterMultiStage = {
        cutting_date: formattedcuttingDate,
        cutting_shift: form.getFieldValue("cuttingShift"),
        cutting_pattern_id: parentReelId,
        data: multiStageDataArr,
      };
      // console.log(cutterMultiStage);
      if (jobcardType == "single_stage") {
        markParentSheetStatus(cutterSingleStage)
          .then((response) => {
            setActionResponse({
              error: false,
              msg: "Production of the parent set is successfully closed.",
            });
            showToaster();
            reFetch(true);
          })
          .catch((error) => {
            setActionResponse(error.response.data);
            showToaster();
          })
          .finally(() => {
            onCloseProduction();
            setTimeout(() => {
              mark ? setIsMarkLoading(false) : setIsSaveLoading(false);
            }, 2500);
          });
        showToaster();
      } else {
        markParentSheetCuttingStatus(cutterMultiStage)
          .then((response) => {
            setActionResponse({
              error: false,
              msg: "Production of the parent set is successfully closed.",
            });
            showToaster();
            reFetch(true);
          })
          .catch((error) => {
            setActionResponse(error.response.data);
            showToaster();
          })
          .finally(() => {
            onCloseProduction();
            setTimeout(() => {
              mark ? setIsMarkLoading(false) : setIsSaveLoading(false);
            }, 2500);
          });
        showToaster();
      }
    }
  };

  const showResponseError = (value) => {
    setResponseError(value);
    setTimeout(() => {
      setResponseError("");
      // onCloseProduction();
    }, 3000);
  };

  const handleStatusChange = (e, key, tabNo) => {
    if (tabNo == 7) {
      let quantityValue = form.getFieldValue(`quantityValue${key}`);
      let unitValue = form.getFieldValue(`quantity_unit${key}`);
      if (unitValue === "sheets") {
        CheckDecimal(quantityValue);
      }
    } else {
      setIsDecimalInput(false);
    }
    form.setFieldsValue({ [`Remark${key}`]: null });
    form.setFieldsValue({ [`quantity${key}`]: null });
    setProductionStatus(
      productionStatus.map((obj, index) => {
        if (key === index) {
          return {
            ...obj,
            status: e.target.value,
            comment: null,
          };
        }
        return obj;
      })
    );
  };

  const handleCommentsChange = (e, key, tab) => {
    if (tab == 7) {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              comment: e.target.value,
            };
          }
          return obj;
        })
      );
    } else {
      if (parentReelDetails?.machine_type !== "cutter") {
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                comment: e.target.value,
              };
            }
            return obj;
          })
        );
      } else {
        let quantityValue = form.getFieldValue(`quantity${key}`);
        let unitValue = form.getFieldValue(`quantityUnit${key}`);
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                comment: e.target.value,
              };
            }
            return obj;
          })
        );
      }
    }
  };

  const handleReelNumber = (e, key, tab) => {
    if (tab == 7) {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              number: e.target.value ? parseFloat(e.target.value) : "",
            };
          }
          return obj;
        })
      );
    } else {
      if (parentReelDetails?.machine_type !== "cutter") {
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                number: e.target.value ? parseFloat(e.target.value) : "",
              };
            }
            return obj;
          })
        );
      }
    }
  };

  const onDateChange = (date, key, tab) => {
    let dispatchDate =
      new Date(date).getFullYear() +
      "-" +
      (new Date(date).getMonth() + 1) +
      "-" +
      new Date(date).getDate() +
      "T00:00:00Z";
    console.log(dispatchDate);
    if (tab == 7) {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              dispatch_date: dispatchDate ? dispatchDate : "",
            };
          }
          return obj;
        })
      );
    } else {
      if (parentReelDetails?.machine_type !== "cutter") {
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                dispatch_date: dispatchDate ? dispatchDate : "",
              };
            }
            return obj;
          })
        );
      }
    }
  };

  const onChangeUnit = (e, key, tab) => {
    if (tab == 7) {
      setIsDecimalInput(false);
      let quantityValue = form.getFieldValue(`quantityValue${key}`);
      if (e === "sheets") {
        CheckDecimal(quantityValue);
      }
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              units: {
                quantity: e,
              },
            };
          }
          return obj;
        })
      );
    } else {
      if (parentReelDetails?.machine_type !== "cutter") {
        let unitValue = form.getFieldValue(`quantity_unit${key}`);
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                units: {
                  quantity: e,
                },
              };
            }
            return obj;
          })
        );
      }
    }
  };

  const handleQuantity = (e, key, tab) => {
    setIsDecimalInput(false);
    let unitValue = form.getFieldValue(`quantity_unit${key}`);
    let rejectedQty = form.getFieldValue(`rejectedQuantityValue${key}`);
    if (unitValue === "sheets") {
      CheckDecimal(e.target.value);
    }
    if (parseFloat(rejectedQty) > parseFloat(e.target.value)) {
      setQtyGreater(true);
    } else {
      setQtyGreater(false);
    }
    if (tab == 7) {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              quantity: e.target.value ? parseFloat(e.target.value) : "",
              ...(e.target.value && {
                units: {
                  quantity: unitValue,
                },
              }),
            };
          }
          return obj;
        })
      );
    } else {
      if (parentReelDetails?.machine_type !== "cutter") {
        setProductionStatus(
          productionStatus.map((obj, index) => {
            if (key === index) {
              return {
                ...obj,
                quantity: e.target.value ? parseFloat(e.target.value) : "",
                ...(e.target.value && {
                  units: {
                    quantity: unitValue,
                  },
                }),
              };
            }
            return obj;
          })
        );
      }
    }
  };

  const handleRejectedQuantity = (e, key, tab) => {
    let unitValue = form.getFieldValue(`quantity_unit${key}`);
    let producedQty = form.getFieldValue(`quantityValue${key}`);

    if (parseFloat(producedQty) < parseFloat(e.target.value)) {
      setQtyGreater(true);
    } else {
      setQtyGreater(false);
    }

    if (tab == 7) {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              rejected_quantity: e.target.value
                ? parseFloat(e.target.value)
                : "",
              ...(e.target.value && {
                units: {
                  quantity: unitValue,
                },
              }),
            };
          }
          return obj;
        })
      );
    }
  };

  const onCoreWeightCheck = (e, key) => {
    if (parentReelDetails?.machine_type !== "cutter") {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              includes_core_weight: e.target.checked,
            };
          }
          return obj;
        })
      );
    }
  };

  const onPackagingWeightCheck = (e, key) => {
    if (parentReelDetails?.machine_type !== "cutter") {
      setProductionStatus(
        productionStatus.map((obj, index) => {
          if (key === index) {
            return {
              ...obj,
              includes_packaging_weight: e.target.checked,
            };
          }
          return obj;
        })
      );
    }
  };

  const handleSubmit = () => {
    if (!isDecimalInput) {
      form.submit();
    }
  };

  const produceAll = () => {
    const body = productionStatus.map((item) => {
      // return {
      // id: item.id,
      // status: "produced",
      return item;
      // };
    });
    // console.log(body);
    markReelsStatus(
      body,
      tabNo == 6 || parentReelDetails?.machine_type == "rewinder"
        ? "rewinder"
        : "cutter",
      true
    );
    // onCloseProduction();
  };

  const onFinish = (e) => {
    if (parentReelDetails?.machine_type !== "cutter" || tabNo == 6) {
      const body = productionStatus.map((item) => {
        // if (item.status === "produced") {
        //   return {
        //     id: item.id,
        //     status: "produced",
        //   };
        // }
        return item;
      });
      markReelsStatus(body, "rewinder");
      // onCloseProduction();
    } else {
      const body = productionStatus.map((item) => {
        // if (item.status === "produced") {
        //   return {
        //     id: item.id,
        //     status: "produced",
        //   };
        // }
        return item;
      });
      console.log(body);
      if (!isDecimalInput) {
        markReelsStatus(body, "cutter");
        // onCloseProduction();
      }
    }
  };

  useEffect(() => {
    form.resetFields();
    setParentReelDetails();

    if (parentReelId) {
      if (tabNo == 6 || jobcardType == "single_stage") {
        getParentReelDetailsById(parentReelId)
          .then((response) => {
            setMappedJumboRolls(
              response.data.data.mapped_jumbo_reels_info.map((item) => {
                return {
                  number: item.number,
                  weight_utilized: parseFloat(item.weight_utilized),
                  units: item.units,
                };
              })
            );
            const data = response.data.data;
            data.reels = data.reels.map((item) =>
             item.category === "so"
                ? { ...item, customer: ["SO"], consignee: ["SO"],so:toHandlePOName(item.so) }
                :{...item,po:toHandlePOName(item.po)}
            );

            setParentReelDetails(data);
            setProductionStatus(
              response.data.data.reels.map((item) => {
                return {
                  id: item.id,
                  status:
                    item.status !== "produced" && item.status !== "rejected"
                      ? "produced"
                      : item.status,
                };
              })
            );
          })
          .catch((error) => console.log(error));
      } else {
        getCuttingParentReelDetailsById(parentReelId)
          .then((response) => {
            console.log(response);
            const data = response.data.data;
            data.reels = data.reels.map((item) =>
              item.category === "so"
                ? { ...item, customer: ["SO"], consignee: ["SO"],so:toHandlePOName(item.so) }
                :{...item,po:toHandlePOName(item.po)}
            );
            setParentReelDetails(data);
            setProductionStatus(
              response.data.data.sheets.map((item) => {
                return {
                  id: item.id,
                  status:
                    item.status !== "produced" && item.status !== "rejected"
                      ? "produced"
                      : item.status,
                };
              })
            );
          })
          .catch((err) => console.log(err));
      }
    }

    return () => {
      setParentReelDetails();
      // setProductionStatus();
    };
  }, [parentReelId]);

  useEffect(() => {
    (async () => {
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  useEffect(() => {
    // setResponseError("");
    form.resetFields();
    if (jobId && (tabNo == 6 || jobcardType == "single_stage")) {
      getJumboReelsForMapping(jobId, jobcardType)
        .then((response) => {
          const data = response.data.data.map((item) => {
            return {
              number: item.number,
              remainingWeight: item.weight,
              weight: item.units && item.units.weight ? item.units.weight : "T",
            };
          });
          setJumboReelData(data);
        })
        .catch((error) => console.log(error));
    }
    return () => {
      setJumboReelData([]);
    };
  }, [parentReelDetails]);

  useEffect(() => {
    if (drawerState && type == "close") {
      let unitObj = {
        weight_utilized: parentWeightUnit,
      };
      let jumboReelsObj = {
        number: data.number,
        weight_utilized: parseFloat(parentWeight?.toFixed(3)),
        units: unitObj,
      };
      let jrArr = [];
      jrArr.push(jumboReelsObj);
      form.setFieldsValue({ [`jumboRoll0`]: data.number });
      if (selectedMachineType == "rewinder") {
        let dateValue = "";
        if (savedDate) dateValue = moment(savedDate, "YYYY-MM-DD");
        form.setFieldsValue({ rewindingDate: dateValue });
        form.setFieldsValue({ rewindingShift: savedShift });
      }
      setMappedJumboRolls(jrArr);
      setRerender(true);
    }
  }, [drawerState]);

  useEffect(() => {
    let temp = mappedJumboRolls;
    setRerender(false);
  }, [mappedJumboRolls]);

  const handleUnit = (e, key) => {
    setIsDecimalInput(false);
    let quantityValue = form.getFieldValue([`quantity${key}`]);
    if (e === "sheets") {
      CheckDecimal(quantityValue);
    }
    setProductionStatus(
      productionStatus.map((obj, index) => {
        if (e === "sheets" && key === index) {
          delete obj["weight"];
        } else if (e !== "sheets" && key === index) {
          delete obj["no_of_sheets"];
        }
        if (key === index) {
          return {
            ...obj,
            ...(e === "sheets" && { no_of_sheets: quantityValue }),
            ...(e !== "sheets" && {
              weight: quantityValue,
              units: {
                weight: e,
              },
            }),
          };
        }
        return obj;
      })
    );
  };

  const onQuantityChange = (e, key) => {
    setIsDecimalInput(false);
    let unitValue = form.getFieldValue(`quantityUnit${key}`);
    if (unitValue === "sheets") {
      CheckDecimal(e.target.value);
    }
    setProductionStatus(
      productionStatus.map((obj, index) => {
        if (key === index) {
          return {
            ...obj,
            ...(unitValue === "sheets" && { no_of_sheets: e.target.value }),
            ...(unitValue !== "sheets" && { weight: e.target.value }),
          };
        }
        return obj;
      })
    );
  };

  const CheckDecimal = (inputTxt) => {
    setIsDecimalInput(false);
    let decimal = /^[-+]?[0-9]+\.[0-9]+$/;
    if (inputTxt?.match(decimal)) {
      setIsDecimalInput(true);
    } else {
      setIsDecimalInput(false);
    }
  };

  const onJumboRoleDropdown = () => {
    setJumboRoleDropdown((prevState) => !prevState);
  };

  const addJumboRoll = () => {
    // setMappedJumboRolls([
    //   ...mappedJumboRolls,
    //   { number: null, weight_utilized: null, units: null },
    // ]);
    let arry = [...mappedJumboRolls];
    let arr = [];
    arr = [...arry, { number: null, weight_utilized: null, units: null }];
    if (arr.length == 1) {
      let unitObj = {
        weight_utilized: parentReelDetails?.units?.weight,
      };
      arr[0]["weight_utilized"] = parseFloat(
        parentReelDetails?.weight?.toFixed(3)
      );
      arr[0]["units"] = unitObj;
      form.setFieldsValue({
        [`jumboRoll0`]: null,
        [`weight0`]: parseFloat(parentReelDetails?.weight?.toFixed(3)),
      });
    }
    setMappedJumboRolls(arr);
  };

  const deleteJumboRoll = (key) => {
    form.setFieldsValue({ [`jumboReel${key}`]: null, [`weight${key}`]: null });
    setMappedJumboRolls(
      mappedJumboRolls.filter((item, index) => index !== key)
    );
    form.setFieldsValue({ [`jumboRoll${key}`]: null });
  };

  const creteNewJumbo = () => {
    let selectedDate = "";
    let selectedShift;
    if (parentReelDetails.machine_type === "rewinder") {
      let dateValue = form.getFieldValue("date");
      if (dateValue)
        selectedDate = moment(dateValue, "DD/MM/YYYY").format("YYYY-MM-DD");
      selectedShift = form.getFieldValue("rewindingShift");
    } else {
    }
    history("../jumbo-reel-records/add-new-jumbo-reel", {
      state: {
        rootPage:
          jobcardType == "single_stage"
            ? "../production-job-cards/job-card-details"
            : "../production-job-cards/multi-stage-job-card-details",
        parentPage: "productionDetails",
        id: jobId,
        parentReelId: parentReelId,
        actionFrom: "mapping drawer",
        type: type,
        machineCode: machineCode,
        productCode: productCode,
        productSpec: productSpec,
        widthKey:
          parentReelDetails.size +
          parentReelDetails.left_edge_trim +
          parentReelDetails.right_edge_trim,
        widthUnit: parentReelDetails.units.size,
        parentWeight: parentReelDetails?.weight,
        parentWeightUnit: parentReelDetails?.units?.weight,
        selectedDate: selectedDate,
        selectedShift: selectedShift,
        jobcardType: jobcardType,
        machineType: parentReelDetails.machine_type,
      },
    });
  };

  const handleJumboRollChange = (index, newValue) => {
    setMappedJumboRolls((prevMappedJumboRolls) => {
      const updatedJumboRolls = prevMappedJumboRolls.map((obj, key) => {
        if (key === index) {
          return {
            ...obj,
            number: newValue,
          };
        }
        return obj;
      });
      form.setFieldsValue({
        [`jumboRoll${index}`]: newValue,
      });

      return updatedJumboRolls;
    });
  };

  return parentReelDetails && measurementData && jumboReelData ? (
    <RightDrawerSidebar
      title="Close Production"
      subtitle=""
      visible={visible}
      onClose={() => {
        onCloseProduction();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              {tabNo == 6 || jobcardType == "single_stage" ? (
                <Form
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                  onFinish={onFinish}
                >
                  <div
                    className="drawerField"
                    style={{ paddingTop: "5px", paddingBottom: "15px" }}
                  >
                    <div className="titleWithText titlebytwo">
                      {parentReelDetails?.machine_type !== "cutter" ||
                      tabNo == 6 ? (
                        <h5>Parent Reel: {parentReelDetails.id}</h5>
                      ) : (
                        <h5>Parent Set: {parentReelDetails.id}</h5>
                      )}
                      {(parentReelDetails?.machine_type !== "cutter" ||
                        tabNo == 6) && (
                        <p style={{ marginTop: "0px" }}>
                          Reel / Core Diameter: {parentReelDetails.reel_od}{" "}
                          {parentReelDetails?.units &&
                          parentReelDetails?.units?.reel_od
                            ? lengthUnit[
                                parentReelDetails.units.reel_od
                              ]?.displayName.toUpperCase()
                            : ""}
                          {" / "}
                          {parentReelDetails.core_id}{" "}
                          {parentReelDetails?.units &&
                          parentReelDetails?.units?.core_id
                            ? lengthUnit[
                                parentReelDetails.units.core_id
                              ]?.displayName.toUpperCase()
                            : ""}
                        </p>
                      )}
                      <p style={{ marginTop: "-3px" }}>
                        Weight: {parentReelDetails.weight?.toFixed(3)}{" "}
                        {parentReelDetails?.units &&
                        parentReelDetails?.units?.parent_roll_weight
                          ? capitalize(
                              weightUnit[
                                parentReelDetails.units.parent_roll_weight
                              ]?.displayName
                            )
                          : "T"}
                      </p>
                      {/* <p style={{ marginTop: "-10px" }}>Mapped Jumbo:</p>*/}
                      {/* <br /> */}
                      {/* {parentReelDetails.mapped_jumbo_reels_info.map((item) => (
                      <p style={{ marginTop: "-10px" }}>
                        {`${item.number} (${item.weight_utilized} ${" "} ${
                          item?.units && item?.units?.weight_utilized
                            ? capitalize(
                                weightUnit[item.units.weight_utilized]
                                  ?.displayName
                              )
                            : "T"
                        })`}
                      </p>
                    ))} */}
                    </div>
                  </div>
                  <div
                    className="drawerField"
                    style={{ paddingBottom: "15px" }}
                  >
                    <div className="titleWithText titlebytwo">
                      <h5>Jumbo Roll</h5>
                      <p>You can join multiple jumbo rolls</p>
                      {mappedJumboRolls.length === 0 ? (
                        <div className="qualityToggled">
                          <GlobalSet
                            style={{ textAlign: "left", marginTop: "16px" }}
                          >
                            <Button
                              className="textTypeBtn textBtnIcon"
                              style={{ marginLeft: "0" }}
                              onClick={() => addJumboRoll()}
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={14}
                                color="#EA655B"
                              />
                              Add a jumbo roll
                            </Button>
                          </GlobalSet>
                        </div>
                      ) : (
                        mappedJumboRolls?.map((reel, index) => {
                          return (
                            <div className="qualityToggled">
                              {index === mappedJumboRolls.length - 1 && (
                                <GlobalSet
                                  style={{
                                    textAlign: "left",
                                    marginTop: "16px",
                                  }}
                                >
                                  <Button
                                    className="textTypeBtn textBtnIcon"
                                    style={{ marginLeft: "0" }}
                                    onClick={() => addJumboRoll()}
                                  >
                                    <Iconmoon
                                      icon="addcircle"
                                      size={14}
                                      color="#EA655B"
                                    />
                                    Add a jumbo roll
                                  </Button>
                                </GlobalSet>
                              )}
                              <div>
                                <div
                                  className="drawerField"
                                  style={{ paddingTop: "0" }}
                                >
                                  <div
                                    className="titleWithText dFlex"
                                    style={{
                                      justifyContent: "space-between",
                                      margin: "10px 0 6px",
                                    }}
                                  >
                                    <h5
                                      style={{
                                        alignSelf: "center",
                                        fontSize: "16px",
                                        fontFamily: "var(--sf-pro-display-m)",
                                        color: "#323130",
                                        marginBottom: "4px",
                                        lineHeight: "16px",
                                      }}
                                    >
                                      Jumbo Roll {index + 1}
                                    </h5>
                                    <GlobalSet className="specialBtn">
                                      <Button
                                        className="textTypeBtn textBtnIcon"
                                        onClick={() => deleteJumboRoll(index)}
                                      >
                                        <Iconmoon
                                          icon="delete"
                                          size={14}
                                          color="#EA655B"
                                        />
                                        Delete
                                      </Button>
                                    </GlobalSet>
                                  </div>
                                  {parentReelDetails.machine_type ===
                                    "rewinder" || tabNo == 6 ? (
                                    <h6
                                      className="utilizedtxt"
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "8px",
                                        fontFamily: "var(--sf-pro-display-m)",
                                        color: "#6b778c",
                                        lineHeight: "16px",
                                      }}
                                    >
                                      You can select a jumbo roll and specify
                                      weight which will be utilized to rewind
                                      this parent reel
                                    </h6>
                                  ) : (
                                    <h6
                                      className="utilizedtxt"
                                      style={{
                                        fontSize: "12px",
                                        marginBottom: "8px",
                                        fontFamily: "var(--sf-pro-display-m)",
                                        color: "#6b778c",
                                        lineHeight: "16px",
                                      }}
                                    >
                                      You can select a jumbo roll and specify
                                      weight which will be utilized to cut this
                                      parent set
                                    </h6>
                                  )}
                                  {parentReelDetails.machine_type ===
                                    "rewinder" || tabNo == 6 ? (
                                    <Form.Item
                                      name={`jumboRoll${index}`}
                                      rules={[
                                        {
                                          required: true,
                                          message: "This is a mandatory field",
                                        },
                                      ]}
                                      initialValue={reel.number}
                                      className="selectForm"
                                    >
                                      <Select
                                        placeholder="Select"
                                        suffixIcon={
                                          jumboRoleDropdown ? (
                                            <DropDownSearchDraw />
                                          ) : (
                                            <DownArrowDraw />
                                          )
                                        }
                                        value={
                                          mappedJumboRolls[index].number ||
                                          undefined
                                        }
                                        showSearch
                                        onBlur={onJumboRoleDropdown}
                                        onFocus={onJumboRoleDropdown}
                                        onChange={(e) =>
                                          handleJumboRollChange(index, e)
                                        }
                                        // allowClear
                                        dropdownRender={(menu) => (
                                          <>
                                            {menu}
                                            <Divider
                                              style={{ marginBottom: "1px" }}
                                            />
                                            <Space>
                                              <GlobalSet className="specialBtn">
                                                <Button
                                                  className="textTypeBtn textBtnIcon"
                                                  style={{
                                                    marginLeft: "0",
                                                    border: "none",
                                                  }}
                                                  onClick={() =>
                                                    creteNewJumbo()
                                                  }
                                                >
                                                  <Iconmoon
                                                    icon="addcircle"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                  Create new jumbo
                                                </Button>
                                              </GlobalSet>
                                            </Space>
                                          </>
                                        )}
                                        options={jumboReelData.map(
                                          (jumboReel) => ({
                                            label:
                                              jumboReel.number +
                                              "(" +
                                              jumboReel.remainingWeight +
                                              " " +
                                              capitalize(
                                                weightUnit[jumboReel.weight]
                                                  ?.displayName
                                              ) +
                                              ")",
                                            value: jumboReel.number,
                                          })
                                        )}
                                      >
                                        {/* {jumboReelData?.map((jumboReel, index) => (
                                    <Option key={jumboReel.number}>
                                      {jumboReel.number} (
                                      {jumboReel.remainingWeight}{" "}
                                      {capitalize(
                                        weightUnit[jumboReel.weight]?.displayName
                                      )}
                                      )
                                    </Option>
                                  ))} */}
                                      </Select>
                                    </Form.Item>
                                  ) : (
                                    <Form.Item
                                      name={`jumboRoll${index}`}
                                      rules={[
                                        {
                                          required: true,
                                          message: "This is a mandatory field",
                                        },
                                      ]}
                                      initialValue={reel.number}
                                      className="selectForm"
                                    >
                                      <Select
                                        placeholder="Select"
                                        suffixIcon={
                                          jumboRoleDropdown ? (
                                            <DropDownSearchDraw />
                                          ) : (
                                            <DownArrowDraw />
                                          )
                                        }
                                        value={
                                          mappedJumboRolls[index].number ||
                                          undefined
                                        }
                                        showSearch
                                        onBlur={onJumboRoleDropdown}
                                        onFocus={onJumboRoleDropdown}
                                        onChange={(e) =>
                                          handleJumboRollChange(index, e)
                                        }
                                      >
                                        {jumboReelData?.map(
                                          (jumboReel, index) => (
                                            <Option key={jumboReel.number}>
                                              {jumboReel.number} (
                                              {jumboReel.remainingWeight}{" "}
                                              {capitalize(
                                                weightUnit[jumboReel.weight]
                                                  ?.displayName
                                              )}
                                              )
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                  )}
                                  {responseError && (
                                    <span
                                      className="errorText"
                                      style={{ color: "#ea4e2c" }}
                                    >
                                      {responseError}
                                    </span>
                                  )}

                                  <h6
                                    className="utilizedtxt"
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "8px",
                                      fontFamily: "var(--sf-pro-display-m)",
                                      color: "#6b778c",
                                      lineHeight: "16px",
                                    }}
                                  >
                                    Weight to be utilized
                                  </h6>
                                  <div className="boxFormType sideplace">
                                    <Form.Item
                                      name={`weight${index}`}
                                      className="textareaField"
                                      rules={[
                                        {
                                          required: true,
                                          message: "This is a mandatory field",
                                        },
                                        {
                                          pattern: new RegExp(/^-?\d+(\.\d+)?$/),
                                          message:
                                            "Only numeric inputs are allowed",
                                        },
                                        {
                                          validator: (_, value) => {
                                            if (!value)
                                              return Promise.resolve();
                                            // if (value > parentReelDetails.weight) {
                                            //   return Promise.reject(
                                            //     "Weight cannot be greater than parent reel weight"
                                            //   );
                                            // } else
                                            if (
                                              +value >
                                              +jumboReelData.filter((item) => {
                                                return (
                                                  item.number ===
                                                  mappedJumboRolls[index].number
                                                );
                                              })[0]?.remainingWeight
                                            ) {
                                              return Promise.reject(
                                                "Weight cannot be greater than remaining weight"
                                              );
                                            } else return Promise.resolve();
                                          },
                                        },
                                      ]}
                                      initialValue={reel.weight_utilized}
                                    >
                                      <Input
                                        placeholder=""
                                        name="test"
                                        onChange={(e) =>
                                          setMappedJumboRolls(
                                            mappedJumboRolls.map((obj, key) => {
                                              if (key === index) {
                                                return {
                                                  ...obj,
                                                  weight_utilized: parseFloat(
                                                    e.target.value
                                                  ),
                                                  units: {
                                                    weight_utilized:
                                                      parentReelDetails?.units &&
                                                      parentReelDetails?.units
                                                        ?.weight
                                                        ? parentReelDetails
                                                            ?.units?.weight
                                                        : "t",
                                                  },
                                                };
                                              }
                                              return obj;
                                            })
                                          )
                                        }
                                      />
                                    </Form.Item>
                                    <span className="nonEditable">
                                      {parentReelDetails?.units &&
                                      parentReelDetails?.units?.weight
                                        ? capitalize(
                                            weightUnit[
                                              parentReelDetails.units.weight
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                      {/* {parentReelDetails.mapped_jumbo_reels_info?.map((item) => (
                      <p>
                        {item.number} ({item.weight_utilized}{" "}
                        {item?.units && item?.units?.weight_utilized
                          ? capitalize(
                              weightUnit[item.units.weight_utilized]
                                ?.displayName
                            )
                          : "T"}
                        )
                      </p>
                    ))} */}
                    </div>
                  </div>
                  {parentReelDetails?.machine_type !== "cutter" ||
                  tabNo == 6 ? (
                    <div className="drawerField removeStar">
                      <div className="titleWithText">
                        <h5>Rewinding Date and Shift</h5>
                        <p>The reel will be rewinded on selected date</p>
                      </div>
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={11}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DatePickerY>
                              <Form.Item
                                label="Date"
                                name="rewindingDate"
                                className="dBlock"
                                initialValue={
                                  parentReelDetails.rewinding_date
                                    ? moment(parentReelDetails.rewinding_date)
                                    : null
                                }
                              >
                                <DatePicker
                                  format={"DD-MM-YYYY"}
                                  disabledDate={(current) => {
                                    return (
                                      current &&
                                      current < moment().subtract(8, "day") &&
                                      current <
                                        (parentReelDetails.rewinding_date
                                          ? moment(
                                              parentReelDetails.rewinding_date
                                            )
                                          : moment())
                                    );
                                  }}
                                />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </Col>
                        <Col span={11}>
                          <div className="boxFormType">
                            <Form.Item
                              label="Shift"
                              name="rewindingShift"
                              rules={[{ required: true }]}
                              className="dBlock"
                              initialValue={parentReelDetails.rewinding_shift}
                            >
                              {/* <Input placeholder="Text"
                            // disabled
                             /> */}
                              <Select
                                placeholder="Select"
                                suffixIcon={<DownArrowDraw />}
                              >
                                {shiftData?.map((shift) => (
                                  <Option key={shift}>{shift}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className="drawerField removeStar">
                      <div className="titleWithText">
                        <h5>Cutting Date and Shift</h5>
                        <p>The reel will be cut on selected date and shift</p>
                      </div>
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={11}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DatePickerY>
                              <Form.Item
                                label="Date"
                                name="cuttingDate"
                                className="dBlock"
                                initialValue={
                                  parentReelDetails.cutting_date
                                    ? moment(parentReelDetails.cutting_date)
                                    : null
                                }
                              >
                                <DatePicker
                                  format={"DD-MM-YYYY"}
                                  disabledDate={(current) => {
                                    return (
                                      current &&
                                      current < moment().subtract(8, "day") &&
                                      current <
                                        (parentReelDetails.cutting_date
                                          ? moment(
                                              parentReelDetails.cutting_date
                                            )
                                          : moment())
                                    );
                                  }}
                                />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </Col>
                        <Col span={11}>
                          <div className="boxFormType">
                            <Form.Item
                              label="Shift"
                              name="cuttingShift"
                              rules={[{ required: true }]}
                              className="dBlock"
                              initialValue={parentReelDetails.cutting_shift}
                            >
                              <Select
                                placeholder="Select"
                                suffixIcon={<DownArrowDraw />}
                              >
                                {shiftData?.map((shift) => (
                                  <Option key={shift}>{shift}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}
                  <div className="drawerField">
                    {parentReelDetails?.machine_type !== "cutter" ||
                    tabNo == 6 ? (
                      <div className="titleWithText">
                        <h5>Mark Reels Production</h5>
                        <p>
                          Specify if the reels are produced and accepted or
                          rejected
                        </p>
                      </div>
                    ) : (
                      <div className="titleWithText">
                        <h5>Mark Sheet Production</h5>
                        <p>
                          Specify if the produced sheets were accepted or
                          rejected
                        </p>
                      </div>
                    )}
                    {parentReelDetails?.machine_type !== "cutter" ||
                    tabNo == 6 ? (
                      <div className="prod-reelset">
                        {parentReelDetails.reels?.map((reel, index) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon="tissue-role"
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {reel.id}
                                  {reel.forced && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {reel.intermediate_reels && (
                                    <span
                                      style={{
                                        color: "#6a6866",
                                        backgroundColor: "#edebe9",
                                        marginTop: "auto",
                                      }}
                                    >
                                      Intermediate
                                    </span>
                                  )}
                                </h4>
                                {reel.reel_type == "order" &&
                                  reel.category != "so" && (
                                    <label>
                                      Delivery Date:{" "}
                                      {moment(reel.delivery_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </label>
                                  )}
                              </div>
                            </div>

                            <div className="prodset-body">
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Weight:</h5>
                                  <p>
                                    {reel.weight}{" "}
                                    {reel?.units && reel.units?.weight
                                      ? capitalize(
                                          weightUnit[reel.units.weight]
                                            ?.displayName
                                        )
                                      : "T"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Reel Size:</h5>
                                  <p>
                                    {reel.reel_size}{" "}
                                    {reel?.units && reel?.units?.reel_size
                                      ? lengthUnit[
                                          reel.units.reel_size
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Length:</h5>
                                  {reel.reel_length}{" "}
                                  {reel?.units && reel?.units?.reel_length
                                    ? lengthUnit[
                                        reel.units.reel_length
                                      ]?.displayName?.toUpperCase()
                                    : "CM"}
                                </div>
                                <div className="prodset-dt prod-50">
                                  {jobcardType === "multi_stage" ? (
                                    !reel.intermediate_reels ? (
                                      reel.reel_type == "order" ? (
                                        <>
                                          <h5>Order Size:</h5>
                                          {!reel.intermediate_reels ? (
                                            <p>
                                              {reel.size}{" "}
                                              {reel?.units && reel?.units?.size
                                                ? lengthUnit[
                                                    reel.units.size
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          ) : (
                                            <p>
                                              {reel.width}{" "}
                                              {reel?.units && reel?.units?.width
                                                ? lengthUnit[
                                                    reel.units.width
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                              {" x "}
                                              {reel.length}{" "}
                                              {reel?.units &&
                                              reel?.units?.length
                                                ? lengthUnit[
                                                    reel.units.length
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <h5>Stock Size:</h5>
                                          {reel.width > 0 && reel.length > 0 ? (
                                            <p>
                                              {reel.width}{" "}
                                              {reel?.units && reel?.units?.width
                                                ? lengthUnit[
                                                    reel.units.width
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                              {" x "}
                                              {reel.length}{" "}
                                              {reel?.units &&
                                              reel?.units?.length
                                                ? lengthUnit[
                                                    reel.units.length
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          ) : (
                                            <p>
                                              {reel.size}{" "}
                                              {reel?.units && reel?.units?.size
                                                ? lengthUnit[
                                                    reel.units.size
                                                  ]?.displayName?.toUpperCase()
                                                : "CM"}
                                            </p>
                                          )}
                                        </>
                                      )
                                    ) : reel.cutting_pattern.length == 12 ||
                                      reel.cutting_pattern.length == 13 ||
                                      reel.cutting_pattern.length == 14 ? (
                                      <>
                                        <h5>Cutting Pattern:</h5>
                                        <p style={{ width: "101px" }}>
                                          {reel.cutting_pattern}
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <h5>Cutting Pattern:</h5>
                                        <p style={{ width: "101px" }}>
                                          <Tooltip title={reel.cutting_pattern}>
                                            {" "}
                                            <span
                                              style={{
                                                display: "flex",
                                                fontSize: "14px",
                                              }}
                                            >
                                              {reel.cutting_pattern[0] +
                                                reel.cutting_pattern[1] +
                                                reel.cutting_pattern[2] +
                                                reel.cutting_pattern[3] +
                                                reel.cutting_pattern[4] +
                                                reel.cutting_pattern[5] +
                                                "..."}{" "}
                                            </span>
                                          </Tooltip>
                                        </p>
                                      </>
                                    )
                                  ) : reel.reel_type == "order" ? (
                                    !reel.intermediate_reels ? (
                                      <>
                                        <h5>Order Size:</h5>
                                        <p>
                                          {reel.size}{" "}
                                          {reel?.units && reel?.units?.size
                                            ? lengthUnit[
                                                reel.units.size
                                              ]?.displayName?.toUpperCase()
                                            : "CM"}
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <h5>Order Size:</h5>
                                        <p>
                                          {reel.width}{" "}
                                          {reel?.units && reel?.units?.width
                                            ? lengthUnit[
                                                reel.units.width
                                              ]?.displayName?.toUpperCase()
                                            : "CM"}
                                          {" x "}
                                          {reel.length}{" "}
                                          {reel?.units && reel?.units?.length
                                            ? lengthUnit[
                                                reel.units.length
                                              ]?.displayName?.toUpperCase()
                                            : "CM"}
                                        </p>
                                      </>
                                    )
                                  ) : reel.width > 0 && reel.length > 0 ? (
                                    <>
                                      <h5>Stock Size:</h5>
                                      <p>
                                        {reel.width}{" "}
                                        {reel?.units && reel?.units?.width
                                          ? lengthUnit[
                                              reel.units.width
                                            ]?.displayName?.toUpperCase()
                                          : "CM"}
                                        {" x "}
                                        {reel.length}{" "}
                                        {reel?.units && reel?.units?.length
                                          ? lengthUnit[
                                              reel.units.length
                                            ]?.displayName?.toUpperCase()
                                          : "CM"}
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <h5>Stock Size:</h5>
                                      <p>
                                        {reel.size}{" "}
                                        {reel?.units && reel?.units?.size
                                          ? lengthUnit[
                                              reel.units.size
                                            ]?.displayName?.toUpperCase()
                                          : "CM"}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div>
                                {jobcardType === "multi_stage" ? (
                                  !reel.intermediate_reels ? (
                                    reel.reel_type == "order" ? (
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>PO/SO NO.:</h5>
                                          {/* <p>{reel.po}</p> */}
                                          {reel?.po?.length > 11 ? (
                                            <Tooltip
                                              placement="bottomLeft"
                                              title={reel?.po}
                                            >
                                              <p>
                                                {reel?.po?.slice(0, 12) + "..."}
                                              </p>
                                            </Tooltip>
                                          ) : (
                                            <p>{reel?.po}</p>
                                          )}
                                          {reel?.so?.length > 11 ? (
                                            <Tooltip
                                              placement="bottomLeft"
                                              title={reel?.so}
                                            >
                                              <p>
                                                {reel?.so?.slice(0, 12) + "..."}
                                              </p>
                                            </Tooltip>
                                          ) : (
                                            <p>{reel?.so}</p>
                                          )}
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>ORDER NO.:</h5>
                                          <p>{reel.order}</p>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="prodset-dt">
                                        <h5>STOCK NO.:</h5>
                                        <p>{`${
                                          reel.stock ? reel.stock : ""
                                        }`}</p>
                                      </div>
                                    )
                                  ) : (
                                    <>
                                      <div className="d-flex prodset-sb">
                                        <div className="prodset-dt prod-50">
                                          <h5>PO/SO NO.:</h5>
                                          {/* <p>{reel.po}</p> */}
                                          <p>
                                            {[
                                              ...(reel?.po || []),
                                              ...(reel?.so || []),
                                            ]
                                              .slice(0, 2)
                                              .map((item, index) => (
                                                <div key={index}>
                                                  {item?.length > 11 ? (
                                                    <Tooltip
                                                      placement="bottomLeft"
                                                      title={item}
                                                    >
                                                      <p>
                                                        {item.slice(0, 12)}
                                                        ...,
                                                      </p>
                                                    </Tooltip>
                                                  ) : (
                                                    <p>{item},</p>
                                                  )}
                                                </div>
                                              ))}

                                            {[
                                              ...(reel?.po || []),
                                              ...(reel?.so || []),
                                            ].length > 2 && (
                                              <Tooltip
                                                title={[
                                                  ...(reel?.po || []),
                                                  ...(reel?.so || []),
                                                ]
                                                  .slice(2)
                                                  .join(", ")}
                                              >
                                                <span
                                                  style={{
                                                    display: "flex",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  &{" "}
                                                  {[
                                                    ...(reel?.po || []),
                                                    ...(reel?.so || []),
                                                  ].length - 2}{" "}
                                                  More
                                                </span>
                                              </Tooltip>
                                            )}
                                          </p>
                                        </div>
                                        <div className="prodset-dt prod-50">
                                          <h5>ORDER NO.:</h5>
                                          {/* <p>{reel.order}</p> */}
                                          <p>
                                            {reel?.order &&
                                              reel?.order?.map(
                                                (item, index) => {
                                                  return (
                                                    index < 2 && (
                                                      <div>
                                                        {item}{" "}
                                                        {index == 1
                                                          ? "...,"
                                                          : reel?.order
                                                              ?.length > 1
                                                          ? ","
                                                          : ""}
                                                      </div>
                                                    )
                                                  );
                                                }
                                              )}

                                            {reel?.order &&
                                              reel?.order?.length >= 2 &&
                                              reel.order?.map((item, index) => {
                                                let tooltipData = "";
                                                for (
                                                  let index = 2;
                                                  index < reel.order?.length;
                                                  index++
                                                ) {
                                                  const data =
                                                    reel.order[index];
                                                  tooltipData =
                                                    tooltipData + data + ", ";
                                                }
                                                tooltipData =
                                                  tooltipData.substring(
                                                    0,
                                                    tooltipData.length - 1
                                                  );
                                                return (
                                                  index == 2 && (
                                                    <Tooltip
                                                      title={tooltipData}
                                                    >
                                                      {" "}
                                                      <span
                                                        style={{
                                                          display: "flex",
                                                          fontSize: "10px",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        &{" "}
                                                        {reel.order.length - 2}{" "}
                                                        More
                                                      </span>
                                                    </Tooltip>
                                                  )
                                                );
                                              })}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="prodset-dt">
                                        <h5>STOCK NO.:</h5>
                                        {/* <p>{`${reel.stock}`}</p> */}
                                        <p>
                                          {reel?.stock &&
                                            reel?.stock?.map((item, index) => {
                                              return (
                                                index < 2 && (
                                                  <div>
                                                    {item}{" "}
                                                    {index == 1
                                                      ? "...,"
                                                      : reel?.stock?.length > 1
                                                      ? ","
                                                      : ""}
                                                  </div>
                                                )
                                              );
                                            })}

                                          {reel?.stock &&
                                            reel?.stock?.length >= 2 &&
                                            reel.stock?.map((item, index) => {
                                              let tooltipData = "";
                                              for (
                                                let index = 2;
                                                index < reel.stock?.length;
                                                index++
                                              ) {
                                                const data = reel.stock[index];
                                                tooltipData =
                                                  tooltipData + data + ", ";
                                              }
                                              tooltipData =
                                                tooltipData.substring(
                                                  0,
                                                  tooltipData.length - 1
                                                );
                                              return (
                                                index == 2 && (
                                                  <Tooltip title={tooltipData}>
                                                    {" "}
                                                    <span
                                                      style={{
                                                        display: "flex",
                                                        fontSize: "10px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      & {reel.stock.length - 2}{" "}
                                                      More
                                                    </span>
                                                  </Tooltip>
                                                )
                                              );
                                            })}
                                        </p>
                                      </div>
                                    </>
                                  )
                                ) : reel.reel_type == "order" ? (
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>PO/SO NO.:</h5>
                                      {/* <p>{reel.po}</p> */}
                                      {reel?.po?.length > 11 ? (
                                        <Tooltip
                                          placement="bottomLeft"
                                          title={reel?.po}
                                        >
                                          <p>
                                            {reel?.po?.slice(0, 12) + "..."}
                                          </p>
                                        </Tooltip>
                                      ) : (
                                        <p>{reel?.po}</p>
                                      )}
                                      {reel?.so?.length > 11 ? (
                                        <Tooltip
                                          placement="bottomLeft"
                                          title={reel?.so}
                                        >
                                          <p>
                                            {reel?.so?.slice(0, 12) + "..."}
                                          </p>
                                        </Tooltip>
                                      ) : (
                                        <p>{reel?.so}</p>
                                      )}
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>ORDER NO.:</h5>
                                      <p>{reel.order}</p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="prodset-dt prod-50">
                                    <h5>STOCK NO.:</h5>
                                    <p>{`${reel.stock ? reel.stock : ""}`}</p>
                                  </div>
                                )}
                              </div>
                              {jobcardType === "multi_stage" ? (
                                !reel.intermediate_reels ? (
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>CX:</h5>
                                      <p>{reel.customer} </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>CNEE:</h5>
                                      <p>{reel.consignee}</p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex prodset-sb">
                                    <div className="prodset-dt prod-50">
                                      <h5>CX:</h5>
                                      {/* <p>{reel.customer}{" "}</p> */}
                                      <p>
                                        {reel?.customer &&
                                          reel?.customer?.map((item, index) => {
                                            return (
                                              index < 2 && (
                                                <div>
                                                  {item}{" "}
                                                  {index == 1
                                                    ? "...,"
                                                    : reel?.customer?.length > 1
                                                    ? ","
                                                    : ""}
                                                </div>
                                              )
                                            );
                                          })}

                                        {reel?.customer &&
                                          reel?.customer?.length >= 2 &&
                                          reel.customer?.map((item, index) => {
                                            let tooltipData = "";
                                            for (
                                              let index = 2;
                                              index < reel.customer?.length;
                                              index++
                                            ) {
                                              const data = reel.customer[index];
                                              tooltipData =
                                                tooltipData + data + ", ";
                                            }
                                            tooltipData = tooltipData.substring(
                                              0,
                                              tooltipData.length - 1
                                            );
                                            return (
                                              index == 2 && (
                                                <Tooltip title={tooltipData}>
                                                  {" "}
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      fontSize: "10px",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    & {reel.customer.length - 2}{" "}
                                                    More
                                                  </span>
                                                </Tooltip>
                                              )
                                            );
                                          })}
                                      </p>
                                    </div>
                                    <div className="prodset-dt prod-50">
                                      <h5>CNEE:</h5>
                                      {/* <p>{reel.consignee}</p> */}
                                      <p>
                                        {reel?.consignee &&
                                          reel?.consignee?.map(
                                            (item, index) => {
                                              return (
                                                index < 2 && (
                                                  <div>
                                                    {item}{" "}
                                                    {index == 1
                                                      ? "...,"
                                                      : reel?.consignee
                                                          ?.length > 1
                                                      ? ","
                                                      : ""}
                                                  </div>
                                                )
                                              );
                                            }
                                          )}

                                        {reel?.consignee &&
                                          reel?.consignee?.length >= 2 &&
                                          reel.consignee?.map((item, index) => {
                                            let tooltipData = "";
                                            for (
                                              let index = 2;
                                              index < reel.consignee?.length;
                                              index++
                                            ) {
                                              const data =
                                                reel.consignee[index];
                                              tooltipData =
                                                tooltipData + data + ", ";
                                            }
                                            tooltipData = tooltipData.substring(
                                              0,
                                              tooltipData.length - 1
                                            );
                                            return (
                                              index == 2 && (
                                                <Tooltip title={tooltipData}>
                                                  {" "}
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      fontSize: "10px",
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    &{" "}
                                                    {reel.consignee.length - 2}{" "}
                                                    More
                                                  </span>
                                                </Tooltip>
                                              )
                                            );
                                          })}
                                      </p>
                                    </div>
                                  </div>
                                )
                              ) : (
                                <div className="d-flex prodset-sb">
                                  <div className="prodset-dt prod-50">
                                    <h5>CX:</h5>
                                    <p>{reel.customer} </p>
                                  </div>
                                  <div className="prodset-dt prod-50">
                                    <h5>CNEE:</h5>
                                    <p>{reel.consignee}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div
                              className="d-block prod-switch"
                              style={{ marginTop: "10px" }}
                            >
                              <label
                                style={{
                                  margin: "0",
                                  fontSize: "12px",
                                  color: "#6b778c",
                                  fontFamily: "var(--sf-pro-display-m)",
                                  lineHeight: "20px",
                                }}
                              >
                                Production Status
                              </label>
                              <div
                                className="switchRadio twoswitch"
                                style={{
                                  justifyContent: "flex-start",
                                  display: "flex",
                                }}
                              >
                                <Radio.Group
                                  options={productionStatusData}
                                  onChange={(e) => handleStatusChange(e, index)}
                                  value={productionStatus[index]?.status}
                                  optionType="button"
                                  buttonStyle="solid"
                                />
                              </div>
                              <div
                                className="removeStar"
                                style={{ marginTop: "10px" }}
                              >
                                <Row className="centerAlign  justifyCSBetween">
                                  <Col style={{ paddingRight: "5px" }} span={9}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        label={"Reel No."}
                                        name={`reelNo${index}`}
                                        rules={[
                                          {
                                            pattern: new RegExp(
                                              /^[a-zA-Z0-9-_ ]+$/
                                            ),
                                            message:
                                              "Only alphanumeric values possible",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={reel?.number}
                                      >
                                        <Input
                                          placeholder="Reel No"
                                          onChange={(e) =>
                                            handleReelNumber(e, index, tabNo)
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col style={{ paddingRight: "5px" }} span={6}>
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        label={"Position"}
                                        name={`position${index}`}
                                        rules={[
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only decimal values possible",
                                          },
                                        ]}
                                        className="dBlock"
                                        initialValue={reel?.position}
                                      >
                                        <Input
                                          placeholder="Position"
                                          disabled={true}
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col span={9}>
                                    <DatePickerY>
                                      <Form.Item
                                        label="Dispatch Date"
                                        name={`dispatchDate${index}`}
                                        className="dBlock"
                                      >
                                        <DatePicker
                                          format={"DD-MM-YYYY"}
                                          disabledDate={(current) => {
                                            return (
                                              current &&
                                              current <
                                                moment().subtract(8, "day") &&
                                              current <
                                                (parentReelDetails.rewinding_date
                                                  ? moment(
                                                      parentReelDetails.rewinding_date
                                                    )
                                                  : moment())
                                            );
                                          }}
                                          onChange={(e) =>
                                            onDateChange(e, index, tabNo)
                                          }
                                        />
                                      </Form.Item>
                                    </DatePickerY>
                                  </Col>
                                </Row>
                                <Row
                                  className="centerAlign  justifyCSBetween"
                                  style={{ marginTop: "-1px" }}
                                >
                                  <Col style={{ paddingRight: "5px" }} span={5}>
                                    <div
                                      className="boxFormType"
                                      style={{
                                        marginBottom: "0",
                                        color: "#a19f9d",
                                        marginTop: "10px",
                                      }}
                                    >
                                      Quantity
                                    </div>
                                  </Col>
                                  <Col
                                    style={{ paddingRight: "5px" }}
                                    span={11}
                                  >
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        // label={ "Reel No." }
                                        name={`quantityValue${index}`}
                                        rules={[
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only decimal values possible",
                                          },
                                        ]}
                                        className="dBlock"
                                      >
                                        <Input
                                          // placeholder="Reel No"
                                          onChange={(e) =>
                                            handleQuantity(e, index, tabNo)
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                  </Col>
                                  <Col style={{ paddingRight: "5px" }} span={8}>
                                    <div className="boxFormType unitSelect">
                                      <Form.Item
                                        // label="Unit"
                                        name={`quantity_unit${index}`}
                                        initialValue={
                                          measurementData?.data
                                            ?.units_management?.weight?.default
                                        }
                                        rules={
                                          [
                                            // {
                                            //   required: true,
                                            //   message: "This field is required",
                                            // },
                                          ]
                                        }
                                        className="dBlock"
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={(e) =>
                                            onChangeUnit(e, index, tabNo)
                                          }
                                        >
                                          {measurementData?.data?.units_management?.weight?.data?.map(
                                            (unitItem) => (
                                              <Option
                                                key={unitItem}
                                                value={unitItem}
                                              >
                                                {capitalize(
                                                  weightUnit[unitItem]
                                                    ?.displayName
                                                )}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                                <Row style={{ marginTop: "-12px" }}>
                                  <div>
                                    <Col>
                                      <Form.Item
                                        name={`coreWeight${index}`}
                                        className="dBlock"
                                        initialValue={
                                          reel?.includes_core_weight
                                        }
                                      >
                                        <Checkbox
                                          onChange={(e) =>
                                            onCoreWeightCheck(e, index)
                                          }
                                        ></Checkbox>
                                        <span
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "13px",
                                            fontFamily:
                                              "var(--sf-pro-display-m)",
                                            color: "#5b5a58",
                                          }}
                                        >
                                          Produced quantity includes core weight
                                        </span>
                                      </Form.Item>
                                    </Col>
                                  </div>
                                </Row>
                                <Row
                                  style={{
                                    marginTop: "-28px",
                                    marginBottom:
                                      productionStatus[index]?.status !=
                                        "rejected" && "-19px",
                                  }}
                                >
                                  <div>
                                    <Col>
                                      <Form.Item
                                        name={`packagingWeight${index}`}
                                        className="dBlock"
                                        initialValue={
                                          reel?.includes_packaging_weight
                                        }
                                      >
                                        <Checkbox
                                          onChange={(e) =>
                                            onPackagingWeightCheck(e, index)
                                          }
                                        ></Checkbox>
                                        <span
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "13px",
                                            fontFamily:
                                              "var(--sf-pro-display-m)",
                                            color: "#5b5a58",
                                          }}
                                        >
                                          Produced quantity includes packaging
                                          weight
                                        </span>
                                      </Form.Item>
                                    </Col>
                                  </div>
                                </Row>
                              </div>
                              {productionStatus[index]?.status ===
                              "rejected" ? (
                                <>
                                  <div className="removeStar">
                                    <Row>
                                      <Col span={24}>
                                        <div
                                          // className="drawField"
                                          style={{
                                            marginTop: "-5px",
                                            borderBottom: "0px solid #edebe9",
                                            marginBottom: "-19px",
                                          }}
                                        >
                                          <Form.Item
                                            name={`Remark${index}`}
                                            rules={[
                                              {
                                                required:
                                                  productionStatus[index]
                                                    ?.status === "rejected" &&
                                                  true,
                                                message:
                                                  "This is a mandatory field",
                                              },
                                              {
                                                max: 100,
                                                message:
                                                  "Max 100 characters allowed",
                                              },
                                            ]}
                                            className=""
                                            onChange={(e) =>
                                              handleCommentsChange(
                                                e,
                                                index,
                                                tabNo
                                              )
                                            }
                                          >
                                            <TextArea
                                              maxLength={100}
                                              style={{ height: 60 }}
                                              placeholder="Reason for rejection"
                                            />
                                          </Form.Item>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </ProductionSet>
                        ))}
                      </div>
                    ) : (
                      <div className="prod-reelset">
                        {parentReelDetails.reels?.map((sheet, index) => (
                          <ProductionSet>
                            <div className="prodset-header">
                              <Iconmoon
                                icon="sheet"
                                size={28}
                                color="#EA655B"
                              />
                              <div className="prodleft-header">
                                <h4>
                                  {sheet.id}
                                  {sheet.forced && (
                                    <span dataset="Priority">Priority</span>
                                  )}
                                  {parentReelDetails.cutter_type &&
                                    parentReelDetails.cutter_type ===
                                      "duplex" && (
                                      <span datasetForStation="Station">
                                        {capitalize(
                                          sheet.station.split("_")[0]
                                        ) +
                                          " " +
                                          sheet.station.split("_")[1]}
                                      </span>
                                    )}
                                </h4>
                                {sheet.reel_type == "order" && (
                                  <label>
                                    Delivery Date:{" "}
                                    {moment(sheet.delivery_date).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </label>
                                )}
                              </div>
                            </div>
                            <div className="prodset-body">
                              {sheet.reel_type == "order" ? (
                                <div>
                                  <div className="prodset-dt">
                                    <h5>PO/SO NO.:</h5>
                                    {/* <p>{sheet.po}</p> */}
                                    {sheet?.po?.length > 11 ? (
                                      <Tooltip
                                        placement="bottomLeft"
                                        title={sheet?.po}
                                      >
                                        <p>{sheet?.po?.slice(0, 12) + "..."}</p>
                                      </Tooltip>
                                    ) : (
                                      <p>{sheet?.po}</p>
                                    )}
                                    {sheet?.so?.length > 11 ? (
                                      <Tooltip
                                        placement="bottomLeft"
                                        title={sheet?.so}
                                      >
                                        <p>{sheet?.so?.slice(0, 12) + "..."}</p>
                                      </Tooltip>
                                    ) : (
                                      <p>{sheet?.so}</p>
                                    )}
                                  </div>
                                  <div className="prodset-dt">
                                    <h5>ORDER NO.:</h5>
                                    <p>{sheet.order}</p>
                                  </div>
                                </div>
                              ) : (
                                <div className="prodset-dt">
                                  <h5>STOCK NO.:</h5>
                                  <p>{`${sheet.stock ? sheet.stock : ""}`}</p>
                                </div>
                              )}
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Size:</h5>
                                  <p>
                                    {sheet.length}
                                    {" x "}
                                    {sheet.width}{" "}
                                    {sheet?.units && sheet?.units?.width
                                      ? lengthUnit[
                                          sheet.units.width
                                        ]?.displayName?.toUpperCase()
                                      : "CM"}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Grain:</h5>
                                  <p>{`${capitalize(sheet.grain)}`}</p>
                                </div>
                              </div>
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>Weight:</h5>
                                  <p>
                                    {sheet.weight}{" "}
                                    {sheet?.units && sheet.units?.weight
                                      ? capitalize(
                                          weightUnit[sheet.units.weight]
                                            ?.displayName
                                        )
                                      : "T"}{" "}
                                  </p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>Sheets:</h5>
                                  <p>{sheet.no_of_sheets}</p>
                                </div>
                              </div>
                            </div>
                            <div className="prodset-footer d-block prod-switch">
                              <label>Production Status</label>
                              <div
                                className="switchRadio twoswitch"
                                style={{
                                  justifyContent: "flex-start",
                                  display: "flex",
                                }}
                              >
                                <Radio.Group
                                  options={productionStatusData}
                                  onChange={(e) => handleStatusChange(e, index)}
                                  value={productionStatus[index]?.status}
                                  optionType="button"
                                  buttonStyle="solid"
                                />
                              </div>
                              {productionStatus[index]?.status ===
                              "rejected" ? (
                                <div>
                                  <div>
                                    <Row
                                      style={{ marginTop: "9px" }}
                                      className="centerAlign  justifyCSBetween closeProdCutting"
                                    >
                                      <Col span={8} className="blockBreak">
                                        <div className="titleWithText">
                                          <p
                                            style={{
                                              marginTop: "8px",
                                              marginBottom: "0px",
                                              fontStyle: "initial",
                                              fontSize: "12px",
                                              fontFamily:
                                                "var(--sf-pro-display-m)",
                                              color: "#6b778c",
                                              lineHeight: "20px",
                                            }}
                                          >
                                            Quantity{" "}
                                          </p>
                                        </div>
                                      </Col>
                                      <Col span={8} className="blockBreak">
                                        <div
                                          className="boxFormType"
                                          style={{ marginBottom: "0" }}
                                        >
                                          <Form.Item
                                            label=""
                                            name={`quantity${index}`}
                                            rules={[
                                              {
                                                pattern: new RegExp(
                                                  /^\d+(\.\d{0,5})?$/
                                                ),
                                                message:
                                                  "Only Numeric value is possible",
                                              },
                                              {
                                                required:
                                                  productionStatus[index]
                                                    ?.status === "rejected" &&
                                                  true,
                                                message:
                                                  "This field is required",
                                              },
                                              {
                                                validator: (_, value) => {
                                                  if (
                                                    value > sheet.no_of_sheets
                                                  ) {
                                                    return Promise.reject(
                                                      "Quantity cannot be greater than number of sheets mentioned in the sheet information card."
                                                    );
                                                  } else {
                                                    return Promise.resolve();
                                                  }
                                                },
                                              },
                                            ]}
                                            className="dBlock"
                                            onChange={(e) => {
                                              onQuantityChange(e, index);
                                            }}
                                          >
                                            <Input
                                              placeholder=""
                                              style={{
                                                fontSize: "12px",
                                                height: "39px",
                                                marginTop: "-2px",
                                              }}
                                              className={
                                                isDecimalInput
                                                  ? "showErrorBorder"
                                                  : ""
                                              }
                                            />
                                          </Form.Item>
                                        </div>
                                        {isDecimalInput ? (
                                          <div style={{ lineHeight: "0px" }}>
                                            <span
                                              style={{
                                                color: "#ea4e2c",
                                                fontSize: "12px",
                                                padding: "0px 0px 0px",
                                                lineHeight: "15px",
                                                fontFamily:
                                                  "var(--sf-pro-text)",
                                              }}
                                            >
                                              {" "}
                                              Only integer input is allowed
                                            </span>
                                          </div>
                                        ) : null}
                                      </Col>
                                      <Col>
                                        <div style={{ width: "92px" }}>
                                          <Form.Item
                                            name={`quantityUnit${index}`}
                                            rules={[]}
                                            className="selectForm"
                                            initialValue={"sheets"}
                                          >
                                            <Select
                                              placeholder="Select"
                                              onChange={(e) => {
                                                handleUnit(e, index);
                                              }}
                                              suffixIcon={<DownArrowDraw />}
                                            >
                                              {measurementData.data.units_management.weight.data?.map(
                                                (unit) => (
                                                  <Option
                                                    key={unit}
                                                    value={unit}
                                                  >
                                                    {
                                                      weightUnit[unit]
                                                        ?.displayName
                                                    }
                                                  </Option>
                                                )
                                              )}
                                              <Option
                                                key={"sheets"}
                                                value={"sheets"}
                                              >
                                                Sheets
                                              </Option>
                                            </Select>
                                          </Form.Item>
                                        </div>
                                      </Col>
                                      {/* <Col span={8} className="blockBreak"></Col>
                                <Col span={8} className="blockBreak">
                               
                                </Col> */}
                                      {/* <Col span={8} className="blockBreak"></Col> */}
                                    </Row>
                                  </div>
                                  <div
                                    className="drawField"
                                    style={{ marginTop: "2px" }}
                                  >
                                    <Form.Item
                                      name={`Remark${index}`}
                                      rules={[
                                        {
                                          required:
                                            productionStatus[index]?.status ===
                                              "rejected" && true,
                                          message: "This is a mandatory field",
                                        },
                                        {
                                          max: 100,
                                          message: "Max 100 characters allowed",
                                        },
                                      ]}
                                      className=""
                                      onChange={(e) =>
                                        handleCommentsChange(e, index, tabNo)
                                      }
                                    >
                                      <TextArea
                                        maxLength={100}
                                        style={{ height: 60 }}
                                        placeholder="Reason for rejection"
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </ProductionSet>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      <Button
                        // htmlType="submit"
                        className="themeBtn"
                        onClick={() => handleSubmit()}
                        loading={isSaveLoading}
                        disabled={isMarkLoading || (tabNo == 7 && isQtyGreater)}
                      >
                        {!isSaveLoading && (
                          <Iconmoon icon="correct" size={16} color="#ffffff" />
                        )}{" "}
                        Save Details
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        className="themeBtn noBg"
                        loading={isMarkLoading}
                        onClick={() => produceAll()}
                        disabled={isSaveLoading || (tabNo == 7 && isQtyGreater)}
                      >
                        {!isMarkLoading && (
                          <Iconmoon icon="correct" size={16} color="#EA655B" />
                        )}{" "}
                        Mark all Produced & Save
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              ) : (
                <Form
                  form={form}
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                  onFinish={onFinish}
                >
                  <div
                    className="drawerField"
                    style={{ paddingTop: "5px", paddingBottom: "15px" }}
                  >
                    <div className="titleWithText titlebytwo">
                      <h5>Parent Set: {parentReelDetails.id}</h5>
                      <p style={{ marginTop: "-3px" }}>
                        Weight: {parentReelDetails.weight?.toFixed(3)}{" "}
                        {parentReelDetails?.units &&
                        parentReelDetails?.units?.parent_roll_weight
                          ? capitalize(
                              weightUnit[
                                parentReelDetails.units.parent_roll_weight
                              ]?.displayName
                            )
                          : "T"}
                      </p>
                      <p style={{ marginTop: "0px" }}>
                        Combination No:{" "}
                        {parentReelDetails.cutting_combination_no}
                      </p>
                    </div>
                  </div>
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Cutting Date and Shift</h5>
                      <p>The reel will be cut on selected date and shift</p>
                    </div>
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={11}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DatePickerY>
                            <Form.Item
                              label="Date"
                              name="cuttingDate"
                              className="dBlock"
                            >
                              <DatePicker
                                format={"DD-MM-YYYY"}
                                disabledDate={(current) => {
                                  return (
                                    current &&
                                    current < moment().subtract(8, "day")
                                  );
                                }}
                              />
                            </Form.Item>
                          </DatePickerY>
                        </div>
                      </Col>
                      <Col span={11}>
                        <div className="boxFormType">
                          <Form.Item
                            label="Shift"
                            name="cuttingShift"
                            rules={[{ required: true }]}
                            className="dBlock"
                          >
                            <Select
                              placeholder="Select"
                              suffixIcon={<DownArrowDraw />}
                            >
                              {shiftData?.map((shift) => (
                                <Option key={shift}>{shift}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Mark Sheet Production</h5>
                      <p>
                        Specify if the produced sheets were accepted or rejected
                      </p>
                    </div>
                    <div className="prod-reelset">
                      {parentReelDetails.sheets?.map((sheet, index) => (
                        <ProductionSet>
                          <div className="prodset-header">
                            <Iconmoon icon="sheet" size={28} color="#EA655B" />
                            <div className="prodleft-header">
                              <h4>
                                {sheet.id}
                                {sheet.forced && (
                                  <span dataset="Priority">Priority</span>
                                )}
                                {parentReelDetails.cutter_type &&
                                  parentReelDetails.cutter_type ===
                                    "duplex" && (
                                    <span datasetForStation="Station">
                                      {capitalize(sheet.station.split("_")[0]) +
                                        " " +
                                        sheet.station.split("_")[1]}
                                    </span>
                                  )}
                              </h4>
                              {sheet.reel_type == "order" && (
                                <label>
                                  Delivery Date:{" "}
                                  {moment(sheet.delivery_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="prodset-body">
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Size:</h5>
                                <p>
                                  {sheet.length}
                                  {sheet.length && sheet.width ? " x " : ""}
                                  {sheet.width}{" "}
                                  {sheet.length && sheet.width
                                    ? `${
                                        sheet.units && sheet.units.width
                                          ? lengthUnit[
                                              sheet.units.width
                                            ]?.displayName?.toUpperCase()
                                          : "CM"
                                      }`
                                    : ""}
                                </p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Grain:</h5>
                                <p>{`${
                                  sheet.grain ? capitalize(sheet.grain) : ""
                                }`}</p>
                              </div>
                            </div>
                            <div className="prodset-dt">
                              <h5>Quantity in plan:</h5>
                              <p>
                                {sheet.weight}{" "}
                                {sheet.units && sheet.units.weight
                                  ? capitalize(
                                      weightUnit[sheet.units.weight]
                                        ?.displayName
                                    )
                                  : "T"}
                                {" | "}
                                {sheet.no_of_sheets}
                                {" Sheets"}
                              </p>
                            </div>
                            {sheet.reel_type == "order" ? (
                              <div>
                                <div className="prodset-dt">
                                  <h5>PO/SO NO.:</h5>
                                  {/* <p>{sheet.po}</p> */}
                                  {sheet?.po?.length > 11 ? (
                                    <Tooltip
                                      placement="bottomLeft"
                                      title={sheet?.po}
                                    >
                                      <p>{sheet?.po?.slice(0, 12) + "..."}</p>
                                    </Tooltip>
                                  ) : (
                                    <p>{sheet?.po}</p>
                                  )}
                                  {sheet?.so?.length > 11 ? (
                                    <Tooltip
                                      placement="bottomLeft"
                                      title={sheet?.so}
                                    >
                                      <p>{sheet?.so?.slice(0, 12) + "..."}</p>
                                    </Tooltip>
                                  ) : (
                                    <p>{sheet?.so}</p>
                                  )}
                                </div>
                                <div className="prodset-dt">
                                  <h5>ORDER NO.:</h5>
                                  <p>{sheet.order}</p>
                                </div>
                              </div>
                            ) : (
                              <div className="prodset-dt">
                                <h5>STOCK NO.:</h5>
                                <p>{`${sheet.stock ? sheet.stock : ""}`}</p>
                              </div>
                            )}
                            {sheet.reel_type == "order" && (
                              <div className="d-flex prodset-sb">
                                <div className="prodset-dt prod-50">
                                  <h5>CX:</h5>
                                  <p>{sheet.customer}</p>
                                </div>
                                <div className="prodset-dt prod-50">
                                  <h5>CNEE:</h5>
                                  <p>{sheet.consignee}</p>
                                </div>
                              </div>
                            )}
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Cutting Position:</h5>
                                <p>{`${sheet.position}`}</p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Dispatch Date:</h5>
                                <p>
                                  {sheet.dispatch_date
                                    ? moment(sheet.dispatch_date).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="prodset-footer d-block prod-switch">
                            <label>Production Status</label>
                            <div
                              className="switchRadio twoswitch"
                              style={{
                                justifyContent: "flex-start",
                                display: "flex",
                              }}
                            >
                              <Radio.Group
                                options={productionStatusData}
                                onChange={(e) =>
                                  handleStatusChange(e, index, tabNo)
                                }
                                value={productionStatus[index]?.status}
                                optionType="button"
                                buttonStyle="solid"
                              />
                            </div>
                            <div
                              className="removeStar"
                              style={{ marginTop: "10px" }}
                            >
                              <Row className="centerAlign  justifyCSBetween">
                                <Col style={{ paddingRight: "5px" }} span={9}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label={"Set No."}
                                      name={`reelNo${index}`}
                                      rules={[
                                        {
                                          pattern: new RegExp(
                                            /^[a-zA-Z0-9-_ ]+$/
                                          ),
                                          message:
                                            "Only alphanumeric values possible",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={sheet?.number}
                                    >
                                      <Input
                                        placeholder="Set No"
                                        onChange={(e) =>
                                          handleReelNumber(e, index, tabNo)
                                        }
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col style={{ paddingRight: "5px" }} span={6}>
                                  <div
                                    className="boxFormType"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <Form.Item
                                      label={"Position"}
                                      name={`position${index}`}
                                      rules={[
                                        {
                                          pattern: new RegExp(/^\d+(\.\d+)?$/),
                                          message:
                                            "Only decimal values possible",
                                        },
                                      ]}
                                      className="dBlock"
                                      initialValue={sheet?.position}
                                    >
                                      <Input
                                        placeholder="Position"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </div>
                                </Col>
                                <Col span={9}>
                                  <DatePickerY>
                                    <Form.Item
                                      label="Dispatch Date"
                                      name={`dispatchDate${index}`}
                                      className="dBlock"
                                    >
                                      <DatePicker
                                        format={"DD-MM-YYYY"}
                                        disabledDate={(current) => {
                                          return (
                                            current &&
                                            current <
                                              moment().subtract(8, "day") &&
                                            current <
                                              (parentReelDetails.dispatch_date
                                                ? moment(
                                                    parentReelDetails.dispatch_date
                                                  )
                                                : moment())
                                          );
                                        }}
                                        onChange={(e) =>
                                          onDateChange(e, index, tabNo)
                                        }
                                      />
                                    </Form.Item>
                                  </DatePickerY>
                                </Col>
                              </Row>
                              {productionStatus[index]?.status == "rejected" ? (
                                <>
                                  <Row
                                    className="centerAlign  justifyCSBetween"
                                    style={{ marginTop: "-15px" }}
                                  >
                                    <Col
                                      style={{ paddingRight: "5px" }}
                                      span={9}
                                    >
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          label={"Produced Qty"}
                                          name={`quantityValue${index}`}
                                          rules={[
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d+)?$/
                                              ),
                                              message:
                                                "Only decimal values possible",
                                            },
                                          ]}
                                          className="dBlock"
                                        >
                                          <Input
                                            onChange={(e) =>
                                              handleQuantity(e, index, tabNo)
                                            }
                                          />
                                        </Form.Item>
                                      </div>
                                      {isDecimalInput ? (
                                        <div
                                          style={{
                                            marginBottom: "17px",
                                            marginTop: "-25px",
                                            fontSize: "12px",
                                            color: "#ea4e2c",
                                            fontFamily: "var(--sf-pro-text)",
                                          }}
                                        >
                                          Only integer input is allowed
                                        </div>
                                      ) : null}
                                    </Col>
                                    <Col
                                      style={{ paddingRight: "5px" }}
                                      span={9}
                                    >
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          label={"Rejected Qty"}
                                          name={`rejectedQuantityValue${index}`}
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "This is a mandatory field",
                                            },
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d+)?$/
                                              ),
                                              message:
                                                "Only decimal values possible",
                                            },
                                          ]}
                                          className="dBlock"
                                        >
                                          <Input
                                            onChange={(e) =>
                                              handleRejectedQuantity(
                                                e,
                                                index,
                                                tabNo
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                    <Col span={6}>
                                      <div className="boxFormType unitSelect">
                                        <Form.Item
                                          label={"Unit"}
                                          name={`quantity_unit${index}`}
                                          initialValue={
                                            measurementData?.data
                                              ?.units_management?.weight
                                              ?.default
                                          }
                                          rules={[]}
                                          className="dBlock"
                                        >
                                          <Select
                                            placeholder="Unit"
                                            suffixIcon={<DownArrowDraw />}
                                            onChange={(e) =>
                                              onChangeUnit(e, index, tabNo)
                                            }
                                          >
                                            {measurementData.data.units_management.weight.data?.map(
                                              (unit) => (
                                                <Option key={unit} value={unit}>
                                                  {
                                                    weightUnit[unit]
                                                      ?.displayName
                                                  }
                                                </Option>
                                              )
                                            )}
                                            <Option
                                              key={"sheets"}
                                              value={"sheets"}
                                            >
                                              Sheets
                                            </Option>
                                          </Select>
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                  {/* {isDecimalInput ? (
                                  <div style={{marginBottom:"17px", marginTop:"-32px", fontSize:"12px", color:"#ea4e2c", fontFamily:"var(--sf-pro-text)"}}>
                                      Only integer input is allowed
                                  </div>
                                ) : null} */}
                                  {isQtyGreater && (
                                    <div
                                      style={{
                                        marginBottom: isDecimalInput
                                          ? "14px"
                                          : "17px",
                                        marginTop: isDecimalInput
                                          ? "-20px"
                                          : "-32px",
                                        fontSize: "12px",
                                        color: "#ea4e2c",
                                        fontFamily: "var(--sf-pro-text)",
                                      }}
                                    >
                                      Rejected qty can not be greater than
                                      produced qty
                                    </div>
                                  )}
                                  <Row
                                    className="centerAlign  justifyCSBetween"
                                    style={{
                                      marginTop: "-12px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <Col span={24}>
                                      <div
                                        className="drawField"
                                        style={{ marginTop: "2px" }}
                                      >
                                        <Form.Item
                                          name={`Remark${index}`}
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "This is a mandatory field",
                                            },
                                            {
                                              max: 100,
                                              message:
                                                "Max 100 characters allowed",
                                            },
                                          ]}
                                          className=""
                                          onChange={(e) =>
                                            handleCommentsChange(
                                              e,
                                              index,
                                              tabNo
                                            )
                                          }
                                        >
                                          <TextArea
                                            maxLength={100}
                                            style={{ height: 60 }}
                                            placeholder="Reason for rejection"
                                          />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              ) : (
                                <Row
                                  className="centerAlign  justifyCSBetween"
                                  style={{
                                    marginTop: "-15px",
                                    marginBottom: "-10px",
                                  }}
                                >
                                  <Col style={{ paddingRight: "5px" }} span={5}>
                                    <div
                                      className="boxFormType"
                                      style={{
                                        marginBottom: "0",
                                        color: "#a19f9d",
                                        marginTop: "10px",
                                      }}
                                    >
                                      Quantity
                                    </div>
                                  </Col>
                                  <Col
                                    style={{ paddingRight: "5px" }}
                                    span={11}
                                  >
                                    <div
                                      className="boxFormType"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <Form.Item
                                        name={`quantityValue${index}`}
                                        rules={[
                                          {
                                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                                            message:
                                              "Only decimal values possible",
                                          },
                                        ]}
                                        className="dBlock"
                                      >
                                        <Input
                                          onChange={(e) =>
                                            handleQuantity(e, index, tabNo)
                                          }
                                        />
                                      </Form.Item>
                                    </div>
                                    {isDecimalInput ? (
                                      <div
                                        style={{
                                          lineHeight: "0px",
                                          marginTop: "-21px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#ea4e2c",
                                            fontSize: "12px",
                                            padding: "0px 0px 0px",
                                            lineHeight: "15px",
                                            fontFamily: "var(--sf-pro-text)",
                                          }}
                                        >
                                          {" "}
                                          Only integer input is allowed
                                        </span>
                                      </div>
                                    ) : null}
                                  </Col>
                                  <Col style={{ paddingRight: "5px" }} span={8}>
                                    <div className="boxFormType unitSelect">
                                      <Form.Item
                                        name={`quantity_unit${index}`}
                                        initialValue={
                                          measurementData?.data
                                            ?.units_management?.weight?.default
                                        }
                                        rules={[]}
                                        className="dBlock"
                                      >
                                        <Select
                                          placeholder="Unit"
                                          suffixIcon={<DownArrowDraw />}
                                          onChange={(e) =>
                                            onChangeUnit(e, index, tabNo)
                                          }
                                        >
                                          {measurementData.data.units_management.weight.data?.map(
                                            (unit) => (
                                              <Option key={unit} value={unit}>
                                                {weightUnit[unit]?.displayName}
                                              </Option>
                                            )
                                          )}
                                          <Option
                                            key={"sheets"}
                                            value={"sheets"}
                                          >
                                            Sheets
                                          </Option>
                                        </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </div>
                          </div>
                        </ProductionSet>
                      ))}
                    </div>
                  </div>
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      <Button
                        className={
                          tabNo == 7 && isQtyGreater
                            ? "themeBtn noBg"
                            : "themeBtn"
                        }
                        onClick={() => handleSubmit()}
                        loading={isSaveLoading}
                        disabled={isMarkLoading || (tabNo == 7 && isQtyGreater)}
                      >
                        {!isSaveLoading && (
                          <Iconmoon
                            icon="correct"
                            size={16}
                            color={
                              tabNo == 7 && isQtyGreater ? "#EA655B" : "#ffffff"
                            }
                          />
                        )}{" "}
                        Save Details
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        className="themeBtn noBg"
                        loading={isMarkLoading}
                        onClick={() => produceAll()}
                        disabled={(tabNo == 7 && isQtyGreater) || isSaveLoading}
                      >
                        {!isMarkLoading && (
                          <Iconmoon icon="correct" size={16} color="#EA655B" />
                        )}{" "}
                        Mark all Produced & Save
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              )}
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default ClosedProductionDrawer;
